import React, { useEffect, useState } from "react";
import axios from "axios";
import Loader from "../../components/Loader";

function OcppStatus() {
  const [status, setStatus] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/ocpp/status`)
      .then(res => setStatus(res.data))
      .catch(err => console.error("Failed to fetch OCPP status:", err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Loader />;

  return (
    <div className="ocpp-status-container">
      <h1>OCPP Status</h1>
      <ul>
        {status.map((s, i) => (
          <li key={i}>
            Charger {s.chargerId}: {s.connectionState}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default OcppStatus;
